import { ProductCategory } from 'app/shared/models/product-category.model';

export const parseProductCategory = (productCategory: string): ProductCategory => {
  if (
    productCategory &&
    (productCategory.toLowerCase() === 'energy' ||
      productCategory.toLowerCase() === 'nbn' ||
      productCategory.toLowerCase() === 'mobile plan')
  ) {
    return productCategory as ProductCategory;
  }
  return null;
};
